<template>
    <input
        :disabled="disabled"
        :style="{ 'opacity': disabled ? 0.5 : 1 }"
        :required="required"
        :class="inputClasses"
        :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" ref="input">
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
    props: {
        modelValue: String|Number,
        error : {
            type: Boolean,
            default: false,
        },
        disabled: Boolean,
        required: Boolean,
    },

    emits: ['update:modelValue'],

    computed: {
        inputClasses() {
            return this.error ? "block w-full text-lg border-red-600 rounded-md focus:border-red-400 focus:outline-none focus:shadow-outline-white form-input"
                : "block w-full text-lg border-dark rounded-md focus:border-black focus:outline-none focus:shadow-outline-white form-input";
        }
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        }
    }
})
</script>
